// src/components/ui/SelectField.jsx
import React, { useMemo } from "react";
import Select from "react-select";

const SelectField = ({
  label,
  name,
  value,
  onChange,
  options = [],
  placeholder = "Seleccionar...",
  displayFn,
  valueKey = "_id",
  isMulti = false,
  isDisabled = false,
}) => {
  const isMobile = useMemo(() => {
    if (typeof window === "undefined") return false;
    return window.innerWidth <= 768;
  }, []);

  const selectOptions = options.map((opt) => ({
    value: opt[valueKey],
    label: displayFn ? displayFn(opt) : opt.name || opt.label,
    raw: opt,
  }));

  const selectedValue = isMulti
    ? selectOptions.filter((opt) =>
        Array.isArray(value) ? value.includes(opt.value) : false,
      )
    : selectOptions.find((opt) => opt.value === value) || null;

  return (
    <div className="w-full min-w-0">
      {label && (
        <label className="block text-sm font-medium mb-1">{label}</label>
      )}

      {/* 📱 MÓVIL */}
      {isMobile && !isMulti ? (
        <select
          name={name}
          value={value || ""}
          disabled={isDisabled}
          onChange={(e) => {
            const selected = options.find(
              (opt) => String(opt[valueKey]) === e.target.value,
            );

            onChange({
              target: {
                name,
                value: e.target.value,
                raw: selected || null,
              },
            });
          }}
          className="w-full border border-gray-300 rounded-md px-3 py-2 bg-white"
        >
          <option value="">{placeholder}</option>
          {options.map((opt) => (
            <option key={opt[valueKey]} value={opt[valueKey]}>
              {displayFn ? displayFn(opt) : opt.name || opt.label}
            </option>
          ))}
        </select>
      ) : (
        /* 💻 DESKTOP o MULTI → react-select */
        <Select
          options={selectOptions}
          value={selectedValue}
          isMulti={isMulti}
          placeholder={placeholder}
          isClearable
          isSearchable
          isDisabled={isDisabled}
          classNamePrefix="react-select"
          menuPortalTarget={document.body}
          menuPosition="fixed"
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          }}
          onChange={(selected) => {
            if (isMulti) {
              onChange({
                target: {
                  name,
                  value: selected ? selected.map((s) => s.raw) : [],
                },
              });
            } else {
              onChange({
                target: {
                  name,
                  value: selected ? selected.value : "",
                  raw: selected?.raw || null,
                },
              });
            }
          }}
        />
      )}
    </div>
  );
};

export default SelectField;
